import type { SYSTableDef } from "../../../../../../../../_ovlclient/src/library/table/tableapi"

export type Costs = {
  Id: string
  ItemCode: string
  ItemType: string
  DocEntry: number
  CostDescription: string
  CostCost: number
  Quantity: number
}

export type Transport = {
  DocEntry: number
  TransportDescription: string
  TransportCost: number
  TransportType: string
  ZipCode: string
  City: string
  Street: string
  StreetNo: string
}

export type Material = {
  Order: number
  LineNum: number
  DocEntry: number
  ItemCode: string
  ItemName: string
  Skl: string
  Length: number
  Width: number
  Height: number
  Quantity: number
  M3: number
  Price: number
  LineTotal: number
}

export type TblCostsColumn = keyof Costs
export type TblCosts = {
  [key: string]: Costs
}

export type TblMaterialColumn = keyof Material
export type TblMaterial = {
  [key: string]: Material
}

export type TblTransportColumn = keyof Transport
export type TblTransport = {
  [key: string]: Transport
}

export let tblOfferingMaterial: SYSTableDef = {
  id: "QUTOfferingMaterial",
  feature: "QUTOfferingDetails",
  database: {
    dataIdField: "LineNum",
    dbInsertMode: "Manual",
  },
  server: {
    endpoint: "offering/offeringmaterial",
  },
  features: {
    edit: true,
    focusToFirstEditableField: false,
    headerMenu: false,
  },
  options: {
    edit: {
      editType: "big",
    },
    rendering: {
      tableControls: { rebuild: { visible: false } },
    },
    initial_sort: { field: "Order", direction: "asc" },
  },
  columns: {
    MaterialDescription: {
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingMaterialDescription",
        visibility: "Table_View",
      },
    },
    Skl: {
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingMaterialSkl",
        readonly: true,
      },
    },

    Quantity: {
      type: "int",
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingMaterialQuantity",
        align: "right",
        visibility: "Table_View",
      },
    },
    M3: {
      type: "decimal",
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingMaterialM3",
        align: "right",
        format: "3digits",
        visibility: "Table_View",
      },
    },
    ItemCode: {
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingMaterialItemCode",
        visibility: "Edit",
      },
      list: {
        valueField: "ItemCode",
        displayField: "ItemName",
        acceptOnlyListValues: true,
        displayValueField: false,
      },
      schema: { nullable: false },
    },
  },
}

export let tblOfferingTransport: SYSTableDef = {
  id: "QUTOfferingTransport",
  feature: "QUTOfferingDetails",
  database: {
    dataIdField: "DocEntry",
    dbInsertMode: "Manual",
  },
  server: {
    endpoint: "offering/offeringtransport",
  },
  options: {
    edit: {
      editType: "big",
    },
    rendering: {
      tableControls: { rebuild: { visible: false } },
      controls: {
        fillSpaceIfNotVisible: false,
      },
    },
  },
  features: {
    edit: true,
    headerMenu: false,
  },

  columns: {
    TransportDescription: {
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingTransportDescription",
        visibility: "Table_View",
      },
    },
    TransportCost: {
      type: "decimal",
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingTransportCost",
        align: "right",
        visibility: "Table_View",
      },
    },
    TransportType: {
      type: "text",
      list: {
        valueField: "TransportType",
        displayField: "TransportTypeDescription",
        displayValueField: false,
      },
      schema: { nullable: false },
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingTransportType",

        visibility: "Edit",
      },
    },
    ZipCode: {
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingTransportZipCode",
        visibility: "Edit",
      },
    },
    City: {
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingTransportCity",
        visibility: "Edit",
      },
    },
    Street: {
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingTransportStreet",
        visibility: "Edit",
      },
    },

    ZipCodeC: {
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingTransportZipCode",
        visibility: "Edit",

        readonly: true,
      },
    },
    CityC: {
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingTransportCity",
        visibility: "Edit",

        readonly: true,
      },
    },
    StreetC: {
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingTransportStreet",
        visibility: "Edit",

        readonly: true,
      },
    },
  },
}

export let tblOfferingCosts: SYSTableDef = {
  id: "QUTOfferingCosts",
  feature: "QUTOfferingDetails",

  database: {
    dataIdField: "Id",
    dbInsertMode: "Manual",
  },
  server: {
    endpoint: "offering/offeringcosts",
  },
  options: {
    rendering: {
      tableControls: { rebuild: { visible: false } },
      controls: { fillSpaceIfNotVisible: false },
    },
    initial_sort: { field: "ItemType", direction: "asc" },
  },
  features: {
    edit: true,
    headerMenu: false,
  },
  columns: {
    CostDescription: {
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingCostsDescription",
        readonly: true,
      },
    },
    Quantity: {
      type: "decimal",
      ui: {
        selectIfFocused: true,
        labelTranslationKey: "QUTOfferingColOfferingCostsQuantity",

        displayEmptyIfValue: 0.0,
      },
    },
    CostCost: {
      type: "decimal",
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingCostsCost",
      },
    },
  },
}
